<template>
  <div>
    <p class="cm-mg-p-wzd">1. {{ $t('common_words.general_information2') }}</p>
    <hr />
    <br />
    <div class="row">
      <div class="col-md-4">
        <fg-input
          type="text"
          :label="`${$t('config.market')} *`"
          v-model="model.name"
          name="config.market"
          v-validate="modelValidations.mercado"
          :error="getError('config.market', true)"
          placeholder="Asia"
        ></fg-input>
      </div>
      <div class="col">
        <select-businesses-component
          ref="select"
          :showLoading="true"
          @onChange="updateSelectedBusinesses"
          @showHideLoading="showHideLoading"
        />
      </div>
    </div>
  </div>
</template>
<script>
import store from '@/store';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinMasters from 'src/util/mixinMasters';
import MixinForm from 'src/mixins/forms/mixin-form';
import Businesses from 'src/components/Selects/Businesses.vue';

export default {
  components: {
    [Businesses.name]: Businesses,
  },

  data() {
    return {
      model: {
        id: null,
        name: null,
        businesses_id: [],
        businesses_names: [],
      },
      modelValidations: {
        mercado: {
          required: true,
        },
      },
      businesses: null,
    };
  },
  mixins: [MixinPermissions, MixinMasters, MixinForm],
  methods: {
    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'businesses_id', bsSelected);
      this.$set(this.model, 'businesses_names', data.names);
    },

    clearSelectedBusinesses() {
      this.$refs.select.$refs.select_associations_ids.selectedInitial = [];
      this.$refs.select.$refs.businesses_ids.selectedInitial = [];
    },

    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', res, this.model);
          this.$emit('fillMarketForm', 'firstStep', this.model);
          return res;
        })
        .then((resp) => {
          if (!resp) return resp;

          if (this.model.businesses_id.length == 0) {
            for (let index of document.getElementsByClassName('bus-rels')) {
              let sel = index.getElementsByClassName('el-input__inner')[0];
              sel.focus();
              sel.classList.add('custom-has-error');
              store.dispatch('utils/removeHasError', sel);
            }
            return false;
          } else return true;
        });
    },
  },

  mounted() {
    this.showHideLoading(false);
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.id = editForm.id;
      this.model.name = editForm.name;
    }
  },
};
</script>
<style></style>
